const { registerBlockType } = wp.blocks;
import classnames from 'classnames';
import { __ } from '@wordpress/i18n';
import { Notice, PanelBody, Button, RangeControl, ToggleControl, SelectControl, TextControl, __experimentalBorderBoxControl as BorderBoxControl, __experimentalBoxControl as BoxControl, GradientPicker, FormToggle, FocalPointPicker, __experimentalUnitControl as UnitControl, BaseControl } from '@wordpress/components';
import { InspectorControls,	useInnerBlocksProps, BlockControls, BlockVerticalAlignmentToolbar, AlignmentToolbar,	__experimentalBlockVariationPicker, useBlockProps, store as blockEditorStore, PanelColorSettings, MediaUpload } from '@wordpress/block-editor';
import { withDispatch, useDispatch, useSelect} from '@wordpress/data';
import { createBlock, createBlocksFromInnerBlocksTemplate, store as blocksStore} from '@wordpress/blocks';
import { hasExplicitPercentColumnWidths, getMappedColumnWidths,	getRedistributedColumnWidths, toWidthPrecision } from './lib/utils';
import { columns as icon } from '@wordpress/icons';
import deprecated from './lib/deprecated';
import variations from './lib/variations';
import transforms from './lib/transforms';
import { get } from 'lodash';
import {colors} from './lib/colors';
const ALLOWED_BLOCKS = [ 'spice-blocks/spice-column' ];

// WordPress dependencies
function ColumnsEditContainer( { attributes, setAttributes, updateAlignment, updateColumns, clientId} ) {
	const { verticalAlignment, textAlignment, contentwidth, contenterwidth, margins, paddings, border, borderradius,  bgColor, shadowColor, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, zindex, bgType, bgGradient, bgImage, bgImageParallax, bgImageSize, bgImageRepeat, bgImageOverlay, bgOverlayColor, bgOverlayPopup, bgOverlayOpacity, bgVideo, bgImagePosition, columngap } = attributes;

	const { count } = useSelect(
		( select ) => {
			return {
				count: select( blockEditorStore ).getBlockCount( clientId ),
			};
		},
		[ clientId ]
	);
	setAttributes({ uniqueid: 'spicesection' +clientId.slice(0,8) });
	const classes = classnames( {
		[ `are-vertically-aligned-${ verticalAlignment }` ]: verticalAlignment,
		[ `has-text-align-${ textAlignment}`]: textAlignment,
		[ `spice-block-container-fluid` ]:  'spice-block-container-fluid',
		[ `hide-desktop` ]:  hidedesktop==false,
		[ `hide-tablet` ]:  hidetablet==false,
		[ `hide-mobile` ]:  hidemobile==false,
		[ `animated ${attributes.durations}`]: durations,
		[ `animated ${attributes.animation}` ]: animation,
	} );

	const blockProps = useBlockProps( {
		className: classes,
	} );
	const innerBlocksProps = useInnerBlocksProps( blockProps, {
		allowedBlocks: ALLOWED_BLOCKS,
		orientation: 'horizontal',
		renderAppender: false,
	} );	

	return (
		<>	
			<BlockControls>
				<BlockVerticalAlignmentToolbar
					onChange={ updateAlignment }
					value={ verticalAlignment }
				/>
				<AlignmentToolbar
					value={attributes.textAlignment}
					onChange={(newalign) => setAttributes({ textAlignment: newalign })}
				/>
			</BlockControls>
			<InspectorControls>
				<PanelBody initialOpen={open} title={__('General Settings','spice-blocks')}>
					<SelectControl
			            label={ __('Content Width','spice-blocks') }
			            value={ contentwidth }
			            options={ [
			            	{ label: __('Container','spice-blocks'), value: 'spice-block-container' },
			                { label: __('Container Fluid','spice-blocks'), value: 'spice-block-container-fluid' },
			            ] }
			            onChange={ (newtext) => setAttributes({ contentwidth: newtext }) }					  
			        /> 

					{ contentwidth === 'spice-block-container' && (
			        <RangeControl
						label={ __( 'Container Width','spice-blocks' ) }
						value={ contenterwidth }
						onChange={(newtext) => setAttributes({ contenterwidth: newtext })}
						min={ 500 }
						max={ 1600 }
					/>)}
					<RangeControl
						className={'spice-section-columns'}
						label={ __( 'Columns','spice-blocks' ) }
						value={ count }
						onChange={ ( value ) => updateColumns( count, value ) }
						min={ 1 }
						max={ Math.max( 6, count ) }
					/>
					<RangeControl
						label={ __( 'Columns Gap','spice-blocks' ) }
						value={ columngap }
						onChange={(newtext) => setAttributes({ columngap: newtext })}
						min={ 0 }
						step={0.01}
						max={ 100}
					/>
					{ count > 6 && (
						<Notice status="warning" isDismissible={ false }>
							{ __(
								'This column count exceeds the recommended amount and may cause visual breakage.','spice-blocks'
							) }
						</Notice>
					) }

					<TextControl
			            label={ __('Z Index','spice-blocks') }			    
			            value={zindex}
        				onChange={(newtext) => setAttributes({ zindex: newtext })}
				    />									
						
							
					<PanelBody initialOpen={false} title={ __('Display','spice-blocks') } className={'spice-panel-edit'}>					
						<ToggleControl
							label={ __('Enable/Disable on Desktop','spice-blocks') }
							checked={hidedesktop}
							onChange={(newval) => setAttributes({ hidedesktop: newval })}
						/>
						<ToggleControl
							label={ __('Enable/Disable on Tablet','spice-blocks') }
							checked={hidetablet}
							onChange={(newval) => setAttributes({ hidetablet: newval })}
						/>
						<ToggleControl
							label={ __('Enable/Disable on Mobile','spice-blocks') }
							checked={hidemobile}
							onChange={(newval) => setAttributes({ hidemobile: newval })}
						/>
					</PanelBody>

					<PanelBody initialOpen={false} title={ __('Animation Effects','spice-blocks') } className={'spice-panel-edit'}> 
						 <SelectControl
                            label={__('Animation','spice-block')}
                            value={ animation }
                            options={ [
                                { label: __('None','spice-blocks'), value: ' ' },
                                { label: __('Bounce','spice-blocks'), value: 'bounce' },
                                { label: __('Flash','spice-blocks'), value: 'flash' },
                                { label: __('Pulse','spice-blocks'), value: 'pulse' },
                                { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                                { label: __('Shake','spice-blocks'), value: 'shake' },
                                { label: __('Swing','spice-blocks'), value: 'swing' },
                                { label: __('Tada','spice-blocks'), value: 'tada' },
                                { label: __('Wobble','spice-blocks'), value: 'wobble' },
                                { label: __('Jello','spice-blocks'), value: 'jello' },
                                { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                                { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                                { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                                { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                                { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                                { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                                { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                                { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                                { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                                { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                                { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                                { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                                { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                                { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                                { label: __('Flip','spice-blocks'), value: 'flip' },
                                { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                                { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                                { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                                { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                                { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                                { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                                { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                                { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                                { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                                { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                                { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                                { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                                { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                                { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                                { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                                { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                                { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' },
                            ] }
                            onChange={ (userVal) => setAttributes({ animation: userVal }) }					  
                        /> 
				        { animation != '' && (
				        	<>
						        <SelectControl
						            label={__('Durations','spice-blocks')}
						            value={ durations }
						            options={ [
						            	{ label: __('Normal','spice-blocks'), value: ' ' },
						                { label: __('Slow','spice-blocks'), value: 'slow' },
						                { label: __('Fast','spice-blocks'), value: 'fast' },
						            ] }
						            onChange={ (newtext) => setAttributes({ durations: newtext }) }					  
						        />  
					        	<TextControl
						            label={__('Delay(ms)','spice-blocks')}			    
						            value={delay}
			        				onChange={(newtext) => setAttributes({ delay: newtext })}
							    />
							</>
							)
						}
					</PanelBody>					
				</PanelBody>
			</InspectorControls>
			<div { ...innerBlocksProps }>
				{bgType !== 'none' && bgType === 'video' && bgVideo && (
					<video autoPlay={true} muted={true} loop={true} id="spice_blocks_video">
						<source src={bgVideo} type="video/mp4" />
					</video>
				)}

				{(bgType === 'image' || bgType === 'video') &&
					bgType !== 'none' &&
					bgImageOverlay && (
						<div className={"spice-blocks-overlay"} style={{
								backgroundColor: bgImageOverlay
									? bgOverlayColor
									: '',
								opacity: bgImageOverlay ? bgOverlayOpacity : '',
							}}>
						</div>
				)}
							
				<div className={`spice-block ${contentwidth}`}>
				{ innerBlocksProps.children }
				</div>
			</div>
		</>
	);
}

const ColumnsEditContainerWrapper = withDispatch(
	( dispatch, ownProps, registry ) => ( {
		/**
		 * Update all child Column blocks with a new vertical alignment setting
		 * based on whatever alignment is passed in. This allows change to parent
		 * to overide anything set on a individual column basis.
		 *
		 * @param {string} verticalAlignment the vertical alignment setting
		 */
		updateAlignment( verticalAlignment ) {
			const { clientId, setAttributes } = ownProps;
			const { updateBlockAttributes } = dispatch( blockEditorStore );
			const { getBlockOrder } = registry.select( blockEditorStore );

			// Update own alignment.
			setAttributes( { verticalAlignment } );

			// Update all child Column Blocks to match.
			const innerBlockClientIds = getBlockOrder( clientId );
			innerBlockClientIds.forEach( ( innerBlockClientId ) => {
				updateBlockAttributes( innerBlockClientId, {
					verticalAlignment,
				} );
			} );
		},

		/**
		 * Updates the column count, including necessary revisions to child Column
		 * blocks to grant required or redistribute available space.
		 *
		 * @param {number} previousColumns Previous column count.
		 * @param {number} newColumns      New column count.
		 */
		updateColumns( previousColumns, newColumns ) {
			const { clientId } = ownProps;
			const { replaceInnerBlocks } = dispatch( blockEditorStore );
			const { getBlocks } = registry.select( blockEditorStore );

			let innerBlocks = getBlocks( clientId );
			const hasExplicitWidths =
				hasExplicitPercentColumnWidths( innerBlocks );

			// Redistribute available width for existing inner blocks.
			const isAddingColumn = newColumns > previousColumns;

			if ( isAddingColumn && hasExplicitWidths ) {
				// If adding a new column, assign width to the new column equal to
				// as if it were `1 / columns` of the total available space.
				const newColumnWidth = toWidthPrecision( 100 / newColumns );

				// Redistribute in consideration of pending block insertion as
				// constraining the available working width.
				const widths = getRedistributedColumnWidths(
					innerBlocks,
					100 - newColumnWidth
				);

				innerBlocks = [
					...getMappedColumnWidths( innerBlocks, widths ),
					...Array.from( {
						length: newColumns - previousColumns,
					} ).map( () => {
						return createBlock( 'spice-blocks/spice-column', {
							width: `${ newColumnWidth }%`,
						} );
					} ),
				];
			} else if ( isAddingColumn ) {
				innerBlocks = [
					...innerBlocks,
					...Array.from( {
						length: newColumns - previousColumns,
					} ).map( () => {
						return createBlock( 'spice-blocks/spice-column' );
					} ),
				];
			} else {
				// The removed column will be the last of the inner blocks.
				innerBlocks = innerBlocks.slice(
					0,
					-( previousColumns - newColumns )
				);

				if ( hasExplicitWidths ) {
					// Redistribute as if block is already removed.
					const widths = getRedistributedColumnWidths(
						innerBlocks,
						100
					);

					innerBlocks = getMappedColumnWidths( innerBlocks, widths );
				}
			}

			replaceInnerBlocks( clientId, innerBlocks );
		},
	} )
)( ColumnsEditContainer );

function Placeholder( { clientId, name, setAttributes } ) {
	const { blockType, defaultVariation, variations } = useSelect(
		( select ) => {
			const {
				getBlockVariations,
				getBlockType,
				getDefaultBlockVariation,
			} = select( blocksStore );

			return {
				blockType: getBlockType( name ),
				defaultVariation: getDefaultBlockVariation( name, 'block' ),
				variations: getBlockVariations( name, 'block' ),
			};
		},
		[ name ]
	);
	const { replaceInnerBlocks } = useDispatch( blockEditorStore );
	const blockProps = useBlockProps();

	return (
		<div { ...blockProps }>
			<__experimentalBlockVariationPicker
				icon={ get( blockType, [ 'icon', 'src' ] ) }
				label={ get( blockType, [ 'title' ] ) }
				variations={ variations }
				onSelect={ ( nextVariation = defaultVariation ) => {
					if ( nextVariation.attributes ) {
						setAttributes( nextVariation.attributes );
					}
					if ( nextVariation.innerBlocks ) {
						replaceInnerBlocks(
							clientId,
							createBlocksFromInnerBlocksTemplate(
								nextVariation.innerBlocks
							),
							true
						);
					}
				} }
				allowSkip
			/>
		</div>
	);
}


const BlockEdit = (props) => {

	const { attributes, setAttributes, clientId } = props;
	const { verticalAlignment, contentwidth, contenterwidth, margins, paddings, border, borderradius, bgColor, shadowColor, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, zindex, bgType, bgGradient, bgImage, bgImageParallax, bgImageSize, bgImageRepeat, bgImageOverlay, bgOverlayColor, bgOverlayPopup, bgOverlayOpacity, bgVideo, bgImagePosition, bordertopradius, borderrightradius, borderbottomradius, borderleftradius,columngap  } = attributes;
	
	function setShadowColor(value) {
		setAttributes({shadowColor:value});
	}
	function setBgColor(value) {
		setAttributes({bgColor:value});
	}
	function setOverlayColor(value) {
		setAttributes({bgOverlayColor:value});
	}

	// Section Background
	let containerBg = '';
	if (bgType !== 'none' && bgType === 'image') {
		containerBg = `url(${bgImage})`;
	} else {
		containerBg = 'none';
	}

	// Section Background Position
	let backgroundPosition = '';
	if(bgType === 'image' && bgImage)
	{
		backgroundPosition =`${bgImagePosition.x * 100}% ${ bgImagePosition.y * 100 }%`
	}
	else
	{
		backgroundPosition = '';
	}

	// Section Background Size
	let backgroundSize = '';
	if(bgType === 'image' && bgImage)
	{
		backgroundSize = bgImageSize;
	}
	else
	{
		backgroundSize = '';
	}

	// Section Image Background Attachment
	let backgroundAttachment = '';
	if(bgType === 'image' && bgImage && bgImageParallax)
	{
		backgroundAttachment='fixed';
	}
	else
	{
		backgroundAttachment='scroll';
	}	
	
	// Section Background Image Repeat
	let backgroundRepeat = '';
	if(bgType === 'image' && bgImage)
	{
		backgroundRepeat = bgImageRepeat;
	}
	else
	{
		backgroundRepeat = '';
	}
							

	const hasInnerBlocks = useSelect(
		( select ) =>
			select( blockEditorStore ).getBlocks( clientId ).length > 0,
		[ clientId ]
	);
	const Component = hasInnerBlocks
		? ColumnsEditContainerWrapper
		: Placeholder;

	const bordertop=(border.top != undefined) ? `${border.top.width} ${border.top.style} ${border.top.color}` : null;
	const borderright=(border.right != undefined) ? `${border.right.width} ${border.right.style} ${border.right.color}` : null;
	const borderbottom=(border.bottom != undefined) ? `${border.bottom.width} ${border.bottom.style} ${border.bottom.color}` : null;
	const borderleft=(border.left != undefined) ? `${border.left.width} ${border.left.style} ${border.left.color}` : null;
	
	return (
	<>
		<style dangerouslySetInnerHTML={{
		  __html: [
		     `#block-${clientId}{
					background-color:${bgColor};
					background-image:${containerBg};
					margin: ${margins.top} ${margins.right} ${margins.bottom} ${margins.left};
					padding: ${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left};
					border: ${border.width} ${border.style} ${border.color};
					border-top:${bordertop};
					border-right:${borderright};
					border-bottom:${borderbottom};
					border-left:${borderleft};
					border-radius: ${bordertopradius} ${borderrightradius} ${borderbottomradius} ${borderleftradius};	
					box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};					
					animation-delay: ${delay}ms;
					background-position: ${backgroundPosition}; 
					background-repeat: ${bgImageRepeat};
					background-size:${backgroundSize};
					background-attachment: ${backgroundAttachment};
					background-repeat: ${backgroundRepeat};
				    z-index: ${zindex};
					overflow: hidden;
					position: relative;
				}
				#block-${clientId} .spice-block.spice-block-container{
		     		max-width:${contenterwidth}px;
		     		gap:${columngap}px;		     	
		     	}
		     	#block-${clientId} .spice-block.spice-block-container-fluid{
		     		gap:${columngap}px;
		     	}`					
		    ].join('\n')
		  }}>
		</style>
		
		<Component { ...props } />
		<InspectorControls>
			<PanelBody initialOpen={false} title={ __('Spacing','spice-blocks') }>
				<BoxControl 
					label={ __('Margin','spice-blocks') }
					inputProps={{ min: -300 }}
					values={margins}
					sides={['top', 'bottom','left','right']}
					allowReset={false}
					units={[]}
					onChange={(newValue) =>
						setAttributes({
							...margins,
							margins: {
										top: newValue.top,
										left: newValue.left,
										right: newValue.right,
										bottom: newValue.bottom,
									},
								})
					}
				/>
				<BoxControl
					values={paddings}
					label={ __('Padding','spice-blocks') }						
						units={[]}
						allowReset={false}
						onChange={(newValue) =>
							setAttributes({
								...paddings,
								paddings: {
									top: newValue.top,
									left: newValue.left,
									right: newValue.right,
									bottom: newValue.bottom,
								},
							})
						}
				/>		
			</PanelBody>
			
			<PanelBody title={__('Background', 'spice-blocks')} initialOpen={false} >
				<PanelColorSettings  initialOpen={open}
					className='spice-block-section-bg-color'
					title={ __('Background Color','spice-blocks') }
					colorSettings={[
						{
						value: bgColor,
						clearable: true,
						onChange: setBgColor,
						label: __('Background Color:','spice-blocks')
						},
					]}
				/>
				<div className="spice_block_section_flex_panel">
					<p className="spice_block_section_panel_label">
						{__('Background Type', 'spice-blocks')}
					</p>
					<div className="spice_block_section_panel">
						
						<Button isSmall={true} isPressed={bgType === 'image'} onClick={() => setAttributes({bgType: 'image',})} >
							<svg width="18" height="15" viewBox="0 0 18 15">
								<path d="M16.083.263h-14.446c-.798 0-1.445.648-1.445 1.447v11.579c0 .8.646 1.447 1.445 1.447h14.446c.798 0 1.445-.648 1.445-1.447v-11.579c0-.8-.646-1.447-1.445-1.447zm-4.334 2.171c2.389 0 2.386 3.618 0 3.618-2.385 0-2.39-3.618 0-3.618zm-9.39 10.855l4.334-5.789 2.965 3.961 2.091-2.514 3.611 4.342h-13.001z" className="svg-fill" fillRule="nonzero"></path>
							</svg>
						</Button>
						
						<Button isSmall={true} onClick={() => setAttributes({bgType: 'none',})}>
							<span className="dashicons dashicons-image-rotate"></span>
						</Button>
					</div>
				</div>

				{/* Image Background */}
				{bgType === 'image' && (
					<Fragment>
						{bgImage ? (
							<Fragment>
								<div className="spice_block_section_preview_container">
									<div className="spice_block_section_preview_image">
										<FocalPointPicker
											url={bgImage}
											value={bgImagePosition}
											onChange={(focalPoint) =>
												setAttributes({
													bgImagePosition:
														focalPoint,
												})
											}
										/>
									</div>
									<div className="spice_block_section_preview_actions">
										<button
											onClick={() =>
												setAttributes({
													bgImage: '',
												})
											}
										>
											<span className="dashicons dashicons-trash"></span>
										</button>
									</div>
								</div>
							</Fragment>
						) : (
							<MediaUpload
								onSelect={(media) =>
									setAttributes({
										bgImage: media.url,
									})
								}
								type="image"
								value={bgImage}
								render={({ open }) => (
									<button
										className="spice_block_section_custom_upload"
										onClick={open}
									>
										<span className="dashicons dashicons-insert"></span>
										<span className="spice_block_section_upload_label">
											{__('Add Image', 'spice-blocks')}
										</span>
									</button>
								)}
							/>
						)}
						<div className="spice_block_section_flex_panel">
							<p className="spice_block_section_panel_label">
								{__('Enable/Disable Parallax','spice-blocks')}
							</p>
							<FormToggle
								checked={bgImageParallax}
								onChange={() =>
									setAttributes({
										bgImageParallax: !bgImageParallax,
									})
								}
							/>
						</div>
						<SelectControl
							label={__('Background Size', 'spice-blocks')}
							options={[
								{
									label: __('Default', 'spice-blocks'),
									value: 'initial',
								},
								{
									label: __('Cover', 'spice-blocks'),
									value: 'cover',
								},
								{
									label: __('Contain', 'spice-blocks'),
									value: 'contain',
								},
								{
									label: __('Auto', 'spice-blocks'),
									value: 'auto',
								},
							]}
							onChange={(size) => {
								setAttributes({ bgImageSize: size });
							}}
							value={bgImageSize}
						/>
						<SelectControl
							label={__('Background Repeat', 'spice-blocks')}
							options={[
								{
									label: __('No Repeat', 'spice-blocks'),
									value: 'no-repeat',
								},
								{
									label: __('Repeat', 'spice-blocks'),
									value: 'repeat',
								},
								{
									label: __('Repeat X', 'spice-blocks'),
									value: 'repeat-x',
								},
								{
									label: __('Repeat Y', 'spice-blocks'),
									value: 'repeat-y',
								},
							]}
							onChange={(value) => {
								setAttributes({ bgImageRepeat: value });
							}}
							value={bgImageRepeat}
						/>
					</Fragment>
				)}				
			</PanelBody>

			{(bgType === 'image') && (
			<Fragment>
			<PanelBody title={__('Background Overlay','spice-blocks')} initialOpen={false} >
				<div className="spice_block_section_flex_panel">
					<p className="spice_block_section_panel_label">{__('Enable/Disable Overlay','spice-blocks')}</p>
					<FormToggle
						checked={bgImageOverlay}
						onChange={() =>
									setAttributes({
												bgImageOverlay: !bgImageOverlay,
												})
								}
					/>
				</div>
				{bgImageOverlay && (
					<Fragment>								
					<PanelColorSettings  
						initialOpen={open}
						className='spice-block-section-bg-overlay'
						title={ __('Overlay Color','spice-blocks') }
						colorSettings={[
							{
								value: bgOverlayColor,
								onChange: setOverlayColor,
								label: __('Overlay Color:','spice-blocks')
							},
						]}
					/>
												
					<RangeControl
						label={__('Overlay Opacity','spice-blocks')}
						value={bgOverlayOpacity}
						onChange={(value) =>
							setAttributes({
									bgOverlayOpacity: value,
							})
						}
						min={0.1}
						max={1}
						step={0.01}
					/>
					</Fragment>
				)}
			</PanelBody>
			</Fragment>
			)}	
			  	
			<PanelBody initialOpen={false} title={ __('Border Settings','spice-blocks') }>
				<BorderBoxControl
					colors={colors}
			        label={ __( 'Border' ,'spice-blocks') }
			        onChange={(newtext) => setAttributes({ border: newtext })}
			        value={ border }
			    />
				<BaseControl className="spice-blocks-border-radius" label={__('Border Radius','spice-blocks')} __nextHasNoMarginBottom={ true }>
			        <UnitControl className={"border-radius-top"} onChange={ (newtext) => setAttributes({ bordertopradius: newtext }) } value={ bordertopradius } placeholder={"Top"} />

			        <UnitControl className={"border-radius-right"} onChange={ (newtext) => setAttributes({ borderrightradius: newtext }) } value={ borderrightradius } placeholder={"right"} />			        
			        
			        <UnitControl className={"border-radius-left"} onChange={ (newtext) => setAttributes({ borderleftradius: newtext }) } value={ borderleftradius } placeholder={"left"}/>

			        <UnitControl className={"border-radius-bottom"}  onChange={ (newtext) => setAttributes({ borderbottomradius: newtext }) } value={ borderbottomradius }  placeholder={"bottom"}/>	       
		        </BaseControl>
			</PanelBody>	

			<PanelBody initialOpen={false} title={ __('Box Shadow','spice-blocks') }>	
				<RangeControl 
					label={ __('Horizontal Shadow(px)','spice-blocks') }			    
				    value={ hshadow}
				    onChange={(newtext) => setAttributes({ hshadow: newtext })}
					min={0}
					max={100}
				/>
				<RangeControl 
					label={ __('Vertical Shadow(px)','spice-blocks') }			    
				    value={ vshadow}
		        	onChange={(newtext) => setAttributes({ vshadow: newtext })}
					min={0}
					max={100}
				/>	
				<RangeControl 
					label={ __('Blur Shadow(px)','spice-blocks') }			    
				    value={ blurshadow}
		        	onChange={(newtext) => setAttributes({ blurshadow: newtext })}
					min={0}
					max={100}
				/>
				<PanelColorSettings  initialOpen={true}
					className='spice-block-section-bg-color'
					title={ __('Box Shadow Color','spice-blocks') }
					colorSettings={[
						{
						value: shadowColor,
						onChange: setShadowColor,
						label: __('Box Shadow:','spice-blocks')
						},
					]}
				/>
			</PanelBody>

		</InspectorControls>	
	</>
	);

}

registerBlockType('spice-blocks/spice-section', {
	apiVersion: 2,
	title: __('Section','spice-blocks'),
	category: 'spice-blocks',
	icon:<svg xmlns="http://www.w3.org/2000/svg" width="24.000000000000004" height="24.000000000000004"><g><g stroke="null"><g stroke="null"><g stroke="null"><path fill="#09A223" stroke="#09A223" d="m0.04638,0.04638l0,23.90723l23.90723,0l0,-23.90723l-23.90723,0zm22.5411,22.5411l-21.17498,0l0,-21.17498l21.17498,0l0,21.17498z"></path><rect fill="#09A223" stroke="null" height="17.75966" width="4.78145" y="3.12017" x="3.12017"></rect><rect fill="#09A223" stroke="null" height="17.75966" width="4.78145" y="3.12017" x="9.60928"></rect><rect fill="#09A223" stroke="null" height="17.75966" width="4.78145" y="3.12017" x="16.09838"></rect></g></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g></g> </g></svg>,
	example: {
	    'attributes' : {
	        'mode' : 'preview',
	    }
	},
	keywords: ['Spice Section', 'Section'],
	attributes: {
		uniqueid:{
			type:'string'
		},
		textAlignment: {
			type: 'string',
			default:''
		},
		verticalAlignment: {
			type: 'string'
		},
		contentwidth:{
			type:'string',
			default:'spice-block-container'
		},
		contenterwidth:{
			type:'number',
			default:1140
		},
		columngap:{
			type:'number',
			default:30
		},
		bgColor:{
	    	type:'string',
	    },
	    shadowColor:{
	    	type:'string',
	    	default:'#ADACAC'
	    }, 
		margins: {
	        default: {
	            top: '0px',	            
	            right: 'auto',
	            bottom: '0px',
	            left: 'auto',
	        }
    	},
		paddings:{
			type: 'object',
		    default: {
		        top: '0px',
		        left: '0px',
		        right: '0px',
		        bottom: '0px',
		      },
		},
		border: {
            type: 'object',
            default: {
                color: '',
                style: '',
                width: '',        
            },
        },
        bordertopradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    borderrightradius:{
	    	type: 'string', 
	    	default: '0px' 
	    },
	    borderbottomradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    borderleftradius:{
	    	type: 'string',
	    	default: '0px'
	    },
        zindex:{
			type:'string'
		},
		hshadow: {
			type: 'number',
			default: 0
		},
		vshadow: {
			type: 'number',
			default: 0
		},
		blurshadow: {
			type: 'number',
			default: 0
		},
		 hidedesktop:{
	    	type: 'boolean',
			default: true
	    },
	    hidetablet:{
	    	type: 'boolean',
			default: true
	    },
	    hidemobile:{
	    	type: 'boolean',
			default: true
	    },
	    animation:{
	    	type:'string',
	    	default:''
	    },
	    durations:{
	    	type:'string',
	    	default:' '
	    },
	    delay:{
	    	type:'string',
	    },
		bgType: {
			"type": "string",
			"default": "none"
		},
		bgGradient: {
			"type": "string",
			"default": "linear-gradient(135deg,#12c2e9 0%,#c471ed 50%,#f64f59 100%)"
		},
		bgImage: {
			"type": "string"
		},
		bgImageParallax: {
			"type": "boolean",
			"default": false
		},
		bgImageSize: {
			"type": "string",
			"default": "cover"
		},
		bgImageRepeat: {
			"type": "string",
			"default": "no-repeat"
		},
		bgImageOverlay: {
			"type": "boolean",
			"default": false
		},
		bgOverlayColor: {
			"type": "string",
			"default": "#000000"
		},
		bgOverlayPopup: {
			"type": "boolean",
			"default": false
		},
		bgOverlayOpacity: {
			"type": "number",
			"default": 0.6
		},
		bgVideo: {
			"type": "string"
		},
		bgImagePosition: {
			"type": "object",
			"default": {
				"x": 0.5,
				"y": 0.5
			}
		}
	},
	"supports": {
		"anchor": true,
		"align": [ "wide", "full" ],
		"html": false,
		"spacing": {
			"blockGap": {
				"__experimentalDefault": "2em",
				"sides": [ "horizontal", "vertical" ]
			},
			"margin": [ "top", "bottom" ],
			"padding": true,
			"__experimentalDefaultControls": {
				"padding": true
			}
		},
		"__experimentalLayout": {
			"allowSwitching": false,
			"allowInheriting": false,
			"allowEditing": false,
			"default": {
				"type": "flex",
				"flexWrap": "nowrap"
			}
		},
		"__experimentalBorder": {
			"color": true,
			"radius": true,
			"style": true,
			"width": true,
			"__experimentalDefaultControls": {
				"color": true,
				"radius": true,
				"style": true,
				"width": true
			}
		},
		
	},
	variations,
	deprecated,
	edit:BlockEdit,
	save: (props) => { 
		const { attributes, setAttributes, clientId } = props;
		const { uniqueid, verticalAlignment, textAlignment, contentwidth, contenterwidth, margins, paddings, border, borderradius, overlayopacity, bgColor, shadowColor, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, zindex, bgType, bgGradient, bgImage, bgImageParallax, bgImageSize, bgImageRepeat, bgImageOverlay, bgOverlayColor, bgOverlayPopup, bgOverlayOpacity, bgVideo, bgImagePosition, bordertopradius, borderrightradius, borderbottomradius, borderleftradius, columngap } = attributes;

	const className = classnames( {
		[`${uniqueid}`]:uniqueid,
		[ `are-vertically-aligned-${ verticalAlignment }` ]: verticalAlignment,
		[ `has-text-align-${ textAlignment}`]: textAlignment,
		[ `spice-block-container-fluid` ]:  `spice-block-container-fluid`,
		[ `hide-desktop` ]:  hidedesktop==false,
		[ `hide-tablet` ]:  hidetablet==false,
		[ `hide-mobile` ]:  hidemobile==false,
		[ `animated ${attributes.durations}`]: durations,
		[ `animated ${attributes.animation}` ]: animation,
	} );
	
	const blockProps = useBlockProps.save( { className } );
	const innerBlocksProps = useInnerBlocksProps.save( blockProps );

	// Section Background
	let containerBg = '';
	if (bgType !== 'none' && bgType === 'image') {
		containerBg = `url(${bgImage})`;
	} else {
		containerBg = 'none';
	}

	// Section Background Position
	let backgroundPosition = '';
	if(bgType === 'image' && bgImage)
	{
		backgroundPosition =`${bgImagePosition.x * 100}% ${ bgImagePosition.y * 100 }%`
	}
	else
	{
		backgroundPosition = '';
	}

	// Section Background Size
	let backgroundSize = '';
	if(bgType === 'image' && bgImage)
	{
		backgroundSize = bgImageSize;
	}
	else
	{
		backgroundSize = '';
	}

	//Image Background Attachment
	let backgroundAttachment = '';
	if(bgType === 'image' && bgImage && bgImageParallax)
	{
		backgroundAttachment='fixed';
	}
	else
	{
		backgroundAttachment='scroll';
	}	
	
	//Background Image Repeat
	let backgroundRepeat = '';
	if(bgType === 'image' && bgImage)
	{
		backgroundRepeat = bgImageRepeat;
	}
	else
	{
		backgroundRepeat = '';
	}
	
	const bordertop=(border.top != undefined) ? `${border.top.width} ${border.top.style} ${border.top.color}` : null;
	const borderright=(border.right != undefined) ? `${border.right.width} ${border.right.style} ${border.right.color}` : null;
	const borderbottom=(border.bottom != undefined) ? `${border.bottom.width} ${border.bottom.style} ${border.bottom.color}` : null;
	const borderleft=(border.left != undefined) ? `${border.left.width} ${border.left.style} ${border.left.color}` : null;

	return( 
	<>
		<style dangerouslySetInnerHTML={{
		  __html: [
		     	`.wp-block-spice-blocks-spice-section.${uniqueid}{
					background-color:${bgColor};
					background-image:${containerBg};
					margin: ${margins.top} ${margins.right} ${margins.bottom} ${margins.left};
					padding: ${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left};
					border: ${border.width} ${border.style} ${border.color};
					border-top:${bordertop};
					border-right:${borderright};
					border-bottom:${borderbottom};
					border-left:${borderleft};
					border-radius: ${bordertopradius} ${borderrightradius} ${borderbottomradius} ${borderleftradius};	
					box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
					animation-delay: ${delay}ms;
					background-position: ${backgroundPosition}; 
					background-repeat: ${bgImageRepeat};
					background-size:${backgroundSize};
					background-attachment: ${backgroundAttachment};
					background-repeat: ${backgroundRepeat};
				    z-index: ${zindex};
					overflow: hidden;
					position: relative;
				}
				.wp-block-spice-blocks-spice-section.${uniqueid} .spice-block.spice-block-container{
			     		max-width:${contenterwidth}px;
			     		gap:${columngap}px
			     }
			    .wp-block-spice-blocks-spice-section.${uniqueid} .spice-block.spice-block-container-fluid{
		     		   gap:${columngap}px;
		     	}`					
		    ].join('\n')
		  }}>
		</style>
		<div { ...innerBlocksProps } >
			
			{(bgType === 'image' ) && bgType !== 'none' && bgImageOverlay && (
				<div className={"spice-blocks-overlay"} style={{
					backgroundColor: bgImageOverlay ? bgOverlayColor : '',
					opacity: bgImageOverlay ? bgOverlayOpacity : '',
					}}>	
				</div>
			)}
			<div className={`spice-block ${contentwidth}`} >
				{ innerBlocksProps.children }
			</div>
		</div>
	</>
	);
	},
	transforms,
});